// Custom Turbo Stream actions for Rails 8 + Turbo
// Register custom actions that extend Turbo's capabilities

// Custom action: full_page_redirect
// Use case: Break out of Turbo Frames to perform full page navigation
// Usage in controller: render inline: "<turbo-stream action=\"full_page_redirect\" url=\"...\"></turbo-stream>", content_type: "text/vnd.turbo-stream.html"

import { logger } from "./logger"

// Clean up modals and scripts before Turbo caches the page
// This prevents modals from auto-opening when navigating back to cached pages
document.addEventListener("turbo:before-cache", () => {
  // 1. Hide any open Bootstrap modals
  document.querySelectorAll('.modal.show').forEach(modalEl => {
    const modal = bootstrap.Modal.getInstance(modalEl)
    if (modal) {
      modal.hide()
    }
    // Reset modal state for cache
    modalEl.classList.remove('show')
    modalEl.setAttribute('aria-hidden', 'true')
    modalEl.style.display = ''
  })

  // 2. Remove any modal backdrops
  document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove())

  // 3. Clean up body classes from modals
  document.body.classList.remove('modal-open')
  document.body.style.overflow = ''
  document.body.style.paddingRight = ''

  // 4. Clear #modals container (removes inline scripts that would re-execute)
  const modalsContainer = document.getElementById('modals')
  if (modalsContainer) {
    modalsContainer.innerHTML = ''
  }

  // 5. Remove any modal-auto-open wrappers (they contain the modal content/scripts)
  document.querySelectorAll('[data-controller*="modal-auto-open"]').forEach(wrapper => {
    wrapper.remove()
  })
})

// Initialize initialization tracker if it doesn't exist
if (!window.__turboInitTracker) {
  window.__turboInitTracker = {
    components: {},
    checkComplete: function() {
      const allComplete = Object.values(this.components).every(status => status === true)
      if (allComplete && !this.logged) {
        this.logged = true
        // Always show in production (special init message)
        logger.init('✓ Turbo initialization complete')
      }
    },
    markComplete: function(component) {
      this.components[component] = true
      this.checkComplete()
    },
    markError: function(component, error) {
      this.components[component] = false
      // Only show errors in development
      logger.error(`✗ ${component} initialization failed:`, error)
      this.checkComplete()
    }
  }
}

try {
  if (typeof Turbo !== 'undefined') {
    Turbo.StreamActions.full_page_redirect = function() {
      const url = this.getAttribute("url")
      if (url) {
        // Clear Turbo's cache to prevent stale page state after redirect
        Turbo.cache.clear()
        // Use real page navigation (not Turbo.visit) to fully reset page state
        // This prevents issues with stale event handlers after Turbo Stream operations
        window.location.replace(url)
      }
    }

    // Custom action: close_modal
    // Properly closes a Bootstrap modal and removes it from the DOM
    // Usage: turbo_stream.action(:close_modal, target: "modal_id")
    Turbo.StreamActions.close_modal = function() {
      const targetId = this.getAttribute("target")
      const modalEl = document.getElementById(targetId)

      if (modalEl) {
        const modal = bootstrap.Modal.getInstance(modalEl)
        if (modal) {
          // Hide the modal properly - this triggers cleanup in modal_auto_open_controller
          modal.hide()
        } else {
          // No Bootstrap instance, just remove the element and backdrop
          modalEl.remove()
          const backdrop = document.querySelector('.modal-backdrop')
          if (backdrop) backdrop.remove()
          document.body.classList.remove('modal-open')
          document.body.style.overflow = ''
          document.body.style.paddingRight = ''
        }
      }

      // Also remove any wrapper element (for modal-auto-open pattern)
      const wrapper = document.querySelector(`[data-controller*="modal-auto-open"]`)
      if (wrapper && wrapper.querySelector(`#${targetId}`)) {
        // Let the hidden.bs.modal event handle cleanup
        // The wrapper will be removed by modal_auto_open_controller
      }
    }

    // Custom action: inject_report_status
    // Creates #reportStatuses container if needed and injects HTML content into it.
    // Used by batch copy progress and any future status bar that reuses the report status overlay.
    // Usage: turbo_stream.action(:inject_report_status, "<div ...>...</div>")
    Turbo.StreamActions.inject_report_status = function() {
      let container = document.getElementById('reportStatuses')
      if (!container) {
        container = document.createElement('div')
        container.id = 'reportStatuses'
        container.className = 'sidebar-aware'

        const sidebarController = document.body.querySelector('[data-controller*="sidebar"]')
        if (sidebarController) {
          if (sidebarController.dataset.sidebarCollapsedValue === 'true') {
            container.classList.add('sidebar-collapsed')
          }
        } else {
          const mainContent = document.querySelector('.main-content-wrapper')
          if (mainContent && mainContent.classList.contains('sidebar-collapsed')) {
            container.classList.add('sidebar-collapsed')
          }
        }

        document.body.appendChild(container)
        container.offsetHeight // force reflow
      }

      // Insert the template content
      container.append(this.templateContent.cloneNode(true))

      // Show the container
      setTimeout(() => {
        container.classList.add('show')
        if (window.updateReportStatusOverlayHeight) {
          setTimeout(() => window.updateReportStatusOverlayHeight(), 50)
        }
      }, 1)
    }

    window.__turboInitTracker.markComplete("Custom Turbo Stream actions")
  } else {
    throw new Error("Turbo not found - cannot register custom actions")
  }
} catch (error) {
  window.__turboInitTracker.markError("Custom Turbo Stream actions", error)
}






